import { render, staticRenderFns } from "./trial-config.vue?vue&type=template&id=49257b33&scoped=true"
import script from "./trial-config.vue?vue&type=script&lang=js"
export * from "./trial-config.vue?vue&type=script&lang=js"
import style0 from "./trial-config.vue?vue&type=style&index=0&id=49257b33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49257b33",
  null
  
)

export default component.exports